module.exports = __webpack_public_path__ + "static/media/arrow-right-medium.c778ee4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-right-medium.svg
// module id = 2512
// module chunks = 0